/*=====================================
    HomeSidebarView

    Author: Ac
    CreateTime: 2018 / 08 / 16
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
import FBFansPage from 'components/commons/FBFansPage';
import CupoyImage from 'components/commons/CupoyImage';
import GLOBAL from 'nonnglobal';
import NewProductsSideBarView from 'components/newproducts/commons/NewProductsSideBarView';

/**
|--------------------------------------------------
| Variables
|--------------------------------------------------
*/
const GAME_TYPE = {
    SALE: 'sale',
    PURCHASE: 'purchase',
};
/*--------------------------
    Styled
--------------------------*/
const Container = styled.div`
    width: ${GlobalStyle.SidebarWidth}px;
`;
const Block = GlobalStyle.BasicBlock.extend`
    width: 100%;
    margin-bottom: ${GlobalStyle.ViewSpace}px;
`;
const Avatar = styled.div`
    border-radius: 50%;
    margin: 0 16px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #E2DFDE;
`;
const MemberInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${
        ({ isNoLogin }) => isNoLogin ?
        `
            justify-content: center;
            height: auto;
            padding-top: 16px;
        `
        :
        `
            padding: 10px 0;
            justify-content: flex-start;
        `
    };
    
    ${Avatar} {
        ${
            ({ isNoLogin }) => isNoLogin ?
            `
                width: 52px;
                height: 52px;
                margin: 0 16px 0 0;
            `
            :
            `
                min-width: 60px;
                width: 60px;
                height: 60px;
                margin: 0 16px;
            `
        };
    }
`;
const MemberName = styled.div`
    font-weight: 600;
    color: #4A4A4A;
    font-size: 16px;
    margin-bottom: 4px;
    line-height: 18px;
`;
const MemberPoint = styled.div`
    color: ${Colors.MAIN_COLOR};
`;
const MemberFuncBar = styled.div`
    position: relative;
    margin: 0 10px;
    display: flex;
    flex-direction: row;
    border-top: 1px solid #E8E8E8;

    &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 50%;
        width: 1px;
        height: 36px;
        background-color: #E8E8E8;
    }
`;
const MemberFuncItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 46px;
    color: #4A4A4A;
    font-size: 12px;
    cursor: pointer;
`;
const MemberFuncItemIcon = styled.div`
    color: #9B9B9B;
    margin-right: 10px;
    font-size: ${({ size }) => size ? `${size}px` : '12px'};
`;
const LoginSignUp = styled.div`
    width: 100%;
    padding: 0 16px;
    margin: 16px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;
const LoginSignUpItem = styled.div`
    width: 97px;
    height: 29px;
    font-size: 12px;
    color: ${({ hasloginBtn }) => hasloginBtn ? '#FFF' : Colors.MAIN_COLOR};
    background-color: ${({ hasloginBtn }) => hasloginBtn ? Colors.MAIN_COLOR : '#FFF'};
    border: 1px solid ${Colors.MAIN_COLOR};
    text-align: center;
    line-height: 27px;
    border-radius: 2px;
    cursor: pointer;
`;
// const VitemTabBar = styled.div`
//     display: flex;
//     flex-direction: row;
//     padding: 0 10px;
//     border-bottom: 1px solid #E8E8E8;
// `;
// const VitemTabItem = styled.div`
//     position: relative;
//     width: 50%;
//     height: 45px;
//     line-height: 45px;
//     text-align: center;
//     color: ${({ isActive }) => isActive ? Colors.MAIN_COLOR : '#4A4A4A'};
//     font-size: 16px;
//     font-weight: 600;
//     cursor: pointer;

//     &::after {
//         content: '';
//         position: absolute;
//         left: 0;
//         bottom: -2px;
//         display: ${({ isActive }) => isActive ? 'block' : 'none'};
//         width: 100%;
//         height: 3px;
//         border-radius: 3px;
//         background-color: ${Colors.MAIN_COLOR};
//     }
// `;
// const VitemList = styled.ul`
//     display: flex;
//     flex-wrap: wrap;
//     flex-direction: row;
//     width: 100%;
//     margin: 0;
//     padding: 10px 16px 7px;
// `;
// const VitemListItem = styled.li`
//     margin-right: 6px;
//     width: calc(50% - 6px);
//     max-width: 50%;
//     color: #4A4A4A;
//     font-size: 14px;
//     margin-bottom: 5px;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//     cursor: pointer;

//     &::before {
//         content: '';
//         display: inline-block;
//         border: 5px solid transparent;
//         border-left-color: ${Colors.MAIN_COLOR};
//         margin-right: 2px;
//     }
// `;
const BlockTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    height: 54px;
    border-bottom: 1px solid #D9D9D9;
    font-size: 20px;
    color: #4A4A4A;
    font-weight: 600;
`;
const BlockMore = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #9B9B9B;
    cursor: pointer;
`;
const BlockMoreIcon = styled.div`
    margin-left: 10px;
    margin-top: -1px;
    font-size: ${({ size }) => size ? `${size}px` : '12px'};
`;
const RankingList = styled.ul`
    padding: 0 10px;
    margin: 0;
`;
const RankingNumber = styled.div`
    min-width: 22px;
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 22px;
    border-radius: 5px;
    margin-right: 10px;
    background-color: ${({ BGColor }) => BGColor ? BGColor : 'transparent'};
    color: #FFF;
`;
const RankingListItem = styled.li`
    width: 100%;
    &:not(:last-child) {
        border-bottom: 1px solid #E8E8E8;
    }
`;
const RankingListItemContent = styled.div`
    padding: 16px 0;
    display: flex;
    flex-direction: row;
    font-size: 15px;
    line-height: 20px;
    color: #4A4A4A;
    font-weight: 600;
    cursor: pointer;
`;
const ProductList = styled.ul`
    margin: 0;
`;
const Product = styled.li`
    margin: 20px 16px 16px;
    cursor: pointer;

    &:first-child {
        margin-top: 16px
    }
`;
const ProductInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: #4A4A4A;
    font-size: 14px;
`;
const ProductImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 65%;
    margin-bottom: 8px;
`;
const ProductImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #E2DFDE;
`;

/*--------------------------
    Main Component
--------------------------*/
class HomeSidebarView extends Component {

    // static propTypes = {
    // };

    constructor(props) {

        super(props);

        this.showSignInDialog = this.showSignInDialog.bind(this);
        this.logout = this.logout.bind(this);
        this.logoutConfirmCallback = this.logoutConfirmCallback.bind(this);
        this.fetchListProfitEvents = this.fetchListProfitEvents.bind(this);
        this.changeGameTypeToSale = this.changeGameType.bind(this, GAME_TYPE.SALE);
        this.changeGameTypeToPurchase = this.changeGameType.bind(this, GAME_TYPE.PURCHASE);

        this.state = {
            gameType: GAME_TYPE.SALE,
        };
    }

    componentDidMount() {

        // const { gameListIds = [] } = this.props;

        // if(gameListIds.length === 0)
        //     this.fetchGameList();

        this.fetchListProfitEvents();
    }

    fetchGameList = () => {

        this.props.gameActions.listGames({ start: 0 });
    }

    fetchListProfitEvents() {
        this.props.profitEventActions.listProfitEvents();
    }

    showSignInDialog (){
        this.props.webActions.showSignInDialog();
    }

    logout(){
        this.props.webActions.openConfirmDialog({
            title: '登出 9199',
            description: '確定要登出？',
            confirmCallback: this.logoutConfirmCallback,
            confirmName: '登出',
            cancelName: '取消',
        });
    }

    logoutConfirmCallback(){
        this.props.memberActions.logout().then(() => {
            window.location.href = '/';
        });
    }

    toProfitEvent = (eventid, clickurl) => {
        
        this.props.profitEventActions.logProfitEventClick({
            eventid,
        });
        window.location.assign(clickurl);
    }

    changeGameType = type => {
        this.setState({ gameType: type });
    }

    validateServerID = ({ gameid, defaultserverid } = {} , useGameType) => {

        const { gameSeverListById } = this.props;
        const { cupoyStateGo } = this.props.webActions;
        const { gameType } = this.state;
    
        if(!defaultserverid && !gameSeverListById[gameid]){
            this.props.gameActions.getGameServerList({
                gameid,
            }).then(() => {
                cupoyStateGo(CupoyRouter.STATES.GAME_TEMP_TRANSACTION, {
                    gameid,
                }, useGameType ? { type: gameType } : null);
            });
        } else {
            cupoyStateGo(CupoyRouter.STATES.GAME_TEMP_TRANSACTION, {
                gameid,
            }, useGameType ? { type: gameType } : null);
        }
    }

    render() {

        const { haslogin } = this.props;

        return (
            <Container>
                {haslogin
                    ? this.renderMemberLogin()
                    : this.renderMemberNoLogin()
                }
                {/* {this.renderVitem()} */}
                {this.renderRanking()}
                {this.renderProfitEvent()}

                <NewProductsSideBarView />

                <FBFansPage />
                
            </Container>
        );
    }

    renderProfitEvent = () => {

        const {
            profitEventMap,
            profitEventIds = [],
        } = this.props;

        // 後台可以選要不要在首頁顯示 需要filter
        const _profitEventIds = profitEventIds.filter(eventid => {

            const event = profitEventMap[eventid];
            const { idxflag } = event;

            return idxflag === 0 ? false : true;
        });

        if(_profitEventIds.length === 0)
            return null;

        return (
            <Block>
                <BlockTitle>
                    好康活動
                    <CupoySrefView
                        statename={CupoyRouter.STATES.PROFITEVENT}
                        stylecomponent={BlockMore}
                    >
                        更多
                        <BlockMoreIcon size={16}>
                            <i className="zmdi zmdi-caret-right-circle"></i>
                        </BlockMoreIcon>
                    </CupoySrefView>
                </BlockTitle>
                <ProductList>
                    {_profitEventIds.map((eventId, index) => {

                        if(index >= 4) return null;

                        const profitEvent = profitEventMap[eventId];

                        const {
                            title = '',
                            eventimg,
                            clickurl,
                        } = profitEvent;
                        
                        return (
                            <Product key={eventId} onClick={() => this.toProfitEvent(eventId, clickurl)}>
                                <ProductImageWrapper>
                                    <CupoyImage
                                        src={GLOBAL.imgSrcRootURL + `/profiteventimgs/${eventId}/${eventimg}`}
                                        stylecomponent={ProductImage}
                                    />
                                </ProductImageWrapper>
                                <ProductInfo>
                                    {title.trim()}
                                </ProductInfo>
                            </Product>
                        );
                    })}
                </ProductList>
            </Block>
        );
    }

    renderRanking = () => {

        const {
            hotgames = [],
        } = this.props;

        if(hotgames.length === 0) return null;

        return (
            <Block>
                <BlockTitle>
                    熱門遊戲
                </BlockTitle>
                <RankingList>
                    {hotgames.map((game, index) => {

                        if(index >= 5) return null;

                        const { gamename = '', gameid } = game;

                        const rank = index + 1;
                        let BGcolor = '';

                        switch (rank) {
                            case 1:
                                BGcolor = '#FF9800';
                                break;
                            case 2:
                                BGcolor = '#FFB433';
                                break;
                            case 3:
                                BGcolor = '#00BCD4';
                                break;
                            case 4:
                                BGcolor = '#4A90E2';
                                break;
                            case 5:
                                BGcolor = '#F75C2F';
                                break;
                            default:
                                break;
                        }

                        return (
                            <RankingListItem
                                BGColor={BGcolor}
                                key={gameid}
                            >
                                <RankingListItemContent
                                    onClick={() => this.validateServerID(game)}
                                >
                                    <RankingNumber BGColor={BGcolor}>
                                        {rank}
                                    </RankingNumber>
                                    {gamename.trim()}
                                </RankingListItemContent>
                            </RankingListItem>
                        );
                    })}
                </RankingList>
            </Block>
        );
    }

    // renderVitem = () => {

    //     const { gameListIds = [], gameListMap } = this.props;
    //     const { gameType } = this.state;

    //     if(gameListIds.length === 0) return null;

    //     return (
    //         <Block>
    //             <VitemTabBar>
    //                 <VitemTabItem
    //                     isActive={gameType === GAME_TYPE.SALE}
    //                     onClick={this.changeGameTypeToSale}
    //                 >
    //                     出售區
    //                 </VitemTabItem>
    //                 <VitemTabItem
    //                     isActive={gameType === GAME_TYPE.PURCHASE}
    //                     onClick={this.changeGameTypeToPurchase}
    //                 >
    //                     收購區
    //                 </VitemTabItem>
    //             </VitemTabBar>
    //             <VitemList>
    //                 {
    //                     gameListIds.map((id, index) => {

    //                         if(index >= 6) return null;

    //                         const game = gameListMap[id];

    //                         const {
    //                             gamename = '',
    //                         } = game;

    //                         return (
    //                             <VitemListItem
    //                                 key={id}
    //                                 onClick={() => this.validateServerID(game, true)}
    //                             >
    //                                 {gamename.trim()}
    //                             </VitemListItem>
    //                         );
    //                     })
    //                 }
    //             </VitemList>
    //         </Block>
    //     );
    // }

    renderMemberLogin = () => {

        const { memberinfo } = this.props;
        
        const {
            membername = '',
            nickname = '',
            bonusremain = 0,
            shownametype,
        } = memberinfo;

        const memerAvatarRsc = GLOBAL.getMemberAvatarRsc(memberinfo);

        return (
            <Block>
                <MemberInfo>
                    <CupoySrefView statename={CupoyRouter.STATES.HELP_UPGRADE_MEMBERSHIP}>
                        <CupoyImage
                            src={memerAvatarRsc}
                            stylecomponent={Avatar}
                            isBackgroundImage
                        />
                    </CupoySrefView>
                    <div>
                        <MemberName>
                            {shownametype === 1
                                ? membername.trim()
                                : nickname.trim()
                            }
                        </MemberName>
                        <MemberPoint>{`發財金 ${bonusremain}`}</MemberPoint>
                    </div>
                </MemberInfo>
                <MemberFuncBar>
                    <CupoySrefView
                        statename={CupoyRouter.STATES.MEMBER_CARD_ORDER_LIST_FINISH}
                        stylecomponent={MemberFuncItem}
                    >
                        <MemberFuncItemIcon size={16}>
                            <i className="zmdi zmdi-file-text"></i>
                        </MemberFuncItemIcon>
                        全部訂單
                    </CupoySrefView>
                    <MemberFuncItem onClick={this.logout}>
                        <MemberFuncItemIcon size={17}>
                            <i className="zmdi zmdi-power-setting"></i>
                        </MemberFuncItemIcon>
                        安全登出
                    </MemberFuncItem>
                </MemberFuncBar>
            </Block>
        );
    }

    renderMemberNoLogin = () => {
        return (
            <Block>
                <MemberInfo isNoLogin>
                    <div>
                        <MemberName>尚未登入</MemberName>
                    </div>
                </MemberInfo>
                <LoginSignUp>
                    <LoginSignUpItem hasloginBtn onClick={this.showSignInDialog}>會員登入</LoginSignUpItem>
                    <CupoySrefView
                        statename={CupoyRouter.STATES.REGISTER}
                        stylecomponent={LoginSignUpItem}
                    >
                        免費註冊
                    </CupoySrefView>
                </LoginSignUp>                
            </Block>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        haslogin: state.member.haslogin,
        memberinfo: state.member.memberinfo,
        profitEventMap: state.profitevent.itemMap,
        profitEventIds: state.profitevent.ids,
        hotgames: state.idxpage.hotgames,
        gameListIds: state.game.gameListIds,
        gameListMap: state.game.gameListMap,
        gameSeverListById: state.game.gameSeverListById,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        memberActions: bindActionCreators(actionCreators.memberActionCreators, dispatch),
        profitEventActions: bindActionCreators(actionCreators.profitEventActionCreators, dispatch),
        gameActions: bindActionCreators(actionCreators.gameActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(HomeSidebarView);